/**
 * Tracks WebRTC DataChannel sessions for P2P social demo clients.
 */
package com.oasisfeng.invaluable.social

import com.oasisfeng.invaluable.p2p.webrtc.DataChannelSession
import kotlin.time.ComparableTimeMark

class SessionTracker {
    private val _sessions = mutableListOf<DataChannelSession>()
    var lastOutbound: DataChannelSession? = null
        private set

    val sessions: List<DataChannelSession> get() = _sessions

    fun add(session: DataChannelSession) {
        _sessions += session
        if (session.outbound) lastOutbound = session
    }

    fun nextId(): Int = (_sessions.maxOfOrNull { it.id } ?: 0) + 1

    /** Count of peer links open right now — the live, local transport fact a node can honestly observe about itself. */
    fun openCount(): Int = _sessions.count { it.isOpen }

    /** [preexistingBefore] is the caller's previous status-read mark (see [com.oasisfeng.invaluable.p2p.core.SessionTimeline.describe]). */
    fun formatSessions(preexistingBefore: ComparableTimeMark? = null): List<String> {
        if (_sessions.isEmpty()) return listOf("(none)")
        return _sessions.map { s ->
            val state = when {
                s.isOpen -> "open"
                s.isClosed -> "closed"
                else -> "connecting"
            }
            val dir = if (s.outbound) "out" else "in"
            "#${s.id} $state $dir ${s.remotePeerId()?.take(8) ?: "????"} ${s.timeline.describe(preexistingBefore)}"
        }
    }
}
